import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './animations/animations.css';
import App from './App';
import { initAnalytics } from './analytics';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

